import { useEffect, useState } from "react"

import { PortalNewsPageObj } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"

import { useLastReadPortalNews } from "entities/portal-news/model/portal-news-store"
import { usePortalNewsListData } from "entities/portal-news/model/usePortalNewsListData"

import { ScrivitoPortalNewsListModel } from "../ScrivitoPortalNewsList"

interface UsePortalNewsListModelArgs {
  page: PortalNewsPageObj | null | undefined
  searchTerm?: string | null
}

export function useScrivitoPortalNewsListModel({
  page,
  searchTerm
}: UsePortalNewsListModelArgs): ScrivitoPortalNewsListModel {
  const { markAllAsRead } = useLastReadPortalNews()
  const { posts, unreadPostIDs } = usePortalNewsListData({ page, searchTerm })
  const [initialUnreadPostIDs] = useState(unreadPostIDs)

  useEffect(() => {
    markAllAsRead()
  }, [])

  return { posts, unreadPostIDs: initialUnreadPostIDs, page }
}
